import {  FETCH_PAYMENTS, LOG_OUT_USER } from "../../actions/actionTypes";


const fetchPaymentsSummaryReducer = (summary, payload) => {
    summary = [];
    for(let s of payload){
        summary.push(s);
    }
    return summary;
}

const paymentsSummaryReducer = (state=[], action) => {
    let summary = state;
    if (action && action.summary && !action.payload.errors && action.type === FETCH_PAYMENTS){
        if(action.payload.source == "PAYMENTS_TAB"){
            summary = fetchPaymentsSummaryReducer(summary, action.summary);
        }   
    } else if (action.type === LOG_OUT_USER){
        summary = []
    }

    return summary;
}

export default paymentsSummaryReducer;